import { render, staticRenderFns } from "./ItemsEditListing.vue?vue&type=template&id=d5037f38&"
import script from "./ItemsEditListing.vue?vue&type=script&lang=js&"
export * from "./ItemsEditListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports